// noinspection JSUnresolvedReference,ES6ConvertVarToLetConst
/* eslint no-undef: 0 */

/**
 * Used in raster worker. MUST be written in ES5
 */
function computeColormapLUTFunc() {
  return [
    [255, 255, 255], [254, 254, 255], [254, 253, 254], [253, 252, 254], [253, 251, 254],
    [252, 250, 253], [251, 249, 253], [251, 248, 253], [250, 247, 252], [250, 246, 252],
    [249, 245, 252], [248, 244, 252], [248, 243, 251], [247, 242, 251], [246, 241, 251],
    [246, 240, 250], [245, 239, 250], [245, 238, 250], [244, 237, 249], [243, 236, 249],
    [243, 235, 249], [242, 234, 248], [242, 233, 248], [241, 232, 248], [240, 231, 247],
    [240, 230, 247], [239, 229, 247], [239, 228, 247], [238, 227, 246], [237, 226, 246],
    [237, 225, 246], [236, 224, 245], [236, 223, 245], [235, 222, 245], [234, 221, 244],
    [234, 220, 244], [233, 219, 244], [233, 218, 243], [232, 217, 243], [231, 216, 243],
    [231, 215, 242], [230, 214, 242], [229, 213, 242], [229, 212, 242], [228, 211, 241],
    [228, 210, 241], [227, 209, 241], [226, 208, 240], [226, 207, 240], [225, 206, 240],
    [225, 205, 239], [224, 204, 239], [223, 203, 239], [223, 202, 238], [222, 201, 238],
    [222, 200, 238], [221, 199, 237], [220, 198, 237], [220, 197, 237], [219, 196, 236],
    [219, 195, 236], [218, 194, 236], [217, 193, 236], [217, 192, 235], [216, 191, 235],
    [215, 190, 235], [215, 189, 234], [214, 188, 234], [214, 187, 234], [213, 186, 233],
    [212, 185, 233], [212, 184, 233], [211, 183, 232], [211, 182, 232], [210, 181, 232],
    [209, 180, 231], [209, 179, 231], [208, 178, 231], [208, 177, 231], [207, 176, 230],
    [206, 175, 230], [206, 174, 230], [205, 173, 229], [205, 172, 229], [204, 171, 229],
    [203, 170, 228], [203, 169, 228], [202, 168, 228], [202, 167, 227], [201, 166, 227],
    [200, 165, 227], [200, 164, 226], [199, 163, 226], [198, 162, 226], [198, 161, 226],
    [197, 160, 225], [197, 159, 225], [196, 158, 225], [195, 157, 224], [195, 156, 224],
    [194, 155, 224], [194, 154, 223], [193, 153, 223], [192, 152, 223], [192, 151, 222],
    [191, 150, 222], [191, 149, 222], [190, 148, 221], [189, 147, 221], [189, 146, 221],
    [188, 145, 220], [188, 144, 220], [187, 143, 220], [186, 142, 220], [186, 141, 219],
    [185, 140, 219], [184, 139, 219], [184, 138, 218], [183, 137, 218], [183, 136, 218],
    [182, 135, 217], [181, 134, 217], [181, 133, 217], [180, 132, 216], [180, 131, 216],
    [179, 130, 216], [178, 129, 215], [178, 128, 215], [177, 127, 215], [177, 126, 215],
    [176, 125, 214], [175, 124, 214], [175, 123, 214], [174, 122, 213], [174, 121, 213],
    [173, 120, 213], [172, 119, 212], [172, 118, 212], [171, 117, 212], [171, 116, 211],
    [170, 115, 211], [169, 114, 211], [169, 113, 210], [168, 112, 210], [167, 111, 210],
    [167, 110, 210], [166, 109, 209], [166, 108, 209], [165, 107, 209], [164, 106, 208],
    [164, 105, 208], [163, 104, 208], [163, 103, 207], [162, 102, 207], [161, 101, 207],
    [161, 100, 206], [160,  99, 206], [160,  98, 206], [159,  97, 205], [158,  96, 205],
    [158,  95, 205], [157,  94, 204], [157,  93, 204], [156,  92, 204], [155,  91, 204],
    [155,  90, 203], [154,  89, 203], [153,  88, 203], [153,  87, 202], [152,  86, 202],
    [152,  85, 202], [151,  84, 201], [150,  83, 201], [150,  82, 201], [149,  81, 200],
    [149,  80, 200], [148,  79, 200], [147,  78, 199], [147,  77, 199], [146,  76, 199],
    [146,  75, 199], [145,  74, 198], [144,  73, 198], [144,  72, 198], [143,  71, 197],
    [143,  70, 197], [142,  69, 197], [141,  68, 196], [141,  67, 196], [140,  66, 196],
    [140,  65, 195], [139,  64, 195], [138,  63, 195], [138,  62, 194], [137,  61, 194],
    [136,  60, 194], [136,  59, 194], [135,  58, 193], [135,  57, 193], [134,  56, 193],
    [133,  55, 192], [133,  54, 192], [132,  53, 192], [132,  52, 191], [131,  51, 191],
    [130,  50, 191], [130,  49, 190], [129,  48, 190], [129,  47, 190], [128,  46, 189],
    [127,  45, 189], [127,  44, 189], [126,  43, 188], [126,  42, 188], [125,  41, 188],
    [124,  40, 188], [124,  39, 187], [123,  38, 187], [122,  37, 187], [122,  36, 186],
    [121,  35, 186], [121,  34, 186], [120,  33, 185], [119,  32, 185], [119,  31, 185],
    [118,  30, 184], [118,  29, 184], [117,  28, 184], [116,  27, 183], [116,  26, 183],
    [115,  25, 183], [115,  24, 183], [114,  23, 182], [113,  22, 182], [113,  21, 182],
    [112,  20, 181], [112,  19, 181], [111,  18, 181], [110,  17, 180], [110,  16, 180],
    [109,  15, 180], [109,  14, 179], [108,  13, 179], [107,  12, 179], [107,  11, 178],
    [106,  10, 178], [105,   9, 178], [105,   8, 178], [104,   7, 177], [104,   6, 177],
    [103,   5, 177], [102,   4, 176], [102,   3, 176], [101,   2, 176], [101,   1, 175],
    [100,   0, 175]
  ];
}

export const VioletLUT = new Uint8Array(computeColormapLUTFunc().flat());

/**
 * Used in raster worker. MUST be written in ES5
 */
function colorizeFunc(pixel) {
  var intensity = pixel[0];
  var rgb = colormapLUT[intensity];
  pixel[0] = rgb[0];
  pixel[1] = rgb[1];
  pixel[2] = rgb[2];
}

/**
 * Used in raster worker. MUST be written in ES5
 */
export function normalizedLookUpTableFunc(min, max) {
  var outputMin = 0;
  var outputMax = 255;
  var range = 256;
  var lut = new Array(range);

  for (var i = 0; i < range; i++) {
    if (i <= min) {
      lut[i] = outputMin;
    } else if (i >= max) {
      lut[i] = outputMax;
    } else {
      lut[i] = Math.trunc(((i - min) / (max - min)) * outputMax);
    }
  }

  return lut;
}

/**
 * Used in raster worker. MUST be written in ES5
 */
function changeIntensityFunc(pixel) {
  for (var i = 0; i < 3; i++) {
    pixel[i] = contrastLUT[pixel[i]];
  }
}

/**
 * Library of primitives* and functions to pass to
 * raster workers.
 *
 * Only String, Number and Boolean seems to be supported.
 * Known types causing issues:
 * - Object
 * - Array
 * - null
 *
 * Functions must only use references available in the worker's context.
 * Functions must be written in ES5.
 */
export const constLib = {
  colormapLUT: false,
  computeColormapLUT: computeColormapLUTFunc,
  colorize: colorizeFunc,

  contrastLUT: false,
  computeContrastLUT: normalizedLookUpTableFunc,
  changeIntensity: changeIntensityFunc
};

/**
 * Used in raster worker. MUST be written in ES5
 */
export function operation(pixels) {
  var pixel = pixels[0];

  if (applyContrast) {
    if (contrastLUT === false) {
      contrastLUT = computeContrastLUT(minBound, maxBound);
    }
    changeIntensity(pixel);
  }

  if (applyColormap) {
    if (colormapLUT === false) {
      colormapLUT = computeColormapLUT();
    }
    colorize(pixel);
  }

  return pixel;
}

function integerToHexa(integer) {
  var hexacode = integer.toString(16);
  return hexacode.length == 1 ? '0' + hexacode : hexacode;
}

function darkerHexaColor(hexa){
  var intColor = parseInt(hexa, 16) - 12;
  if(intColor < 0) intColor = 0;
  return integerToHexa(intColor);
}

export function getDarkerColor(hexacode) {
  var darkerRed = darkerHexaColor(hexacode[1]+hexacode[2]);
  var darkerGreen = darkerHexaColor(hexacode[3]+hexacode[4]);
  var darkerBlue = darkerHexaColor(hexacode[5]+hexacode[6]);
  return '#' + darkerRed + darkerGreen + darkerBlue;
}

export function randomColor() {
  return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
}

export let presetColors = [
  '#F44E3B',
  '#FB9E00',
  '#FCDC00',
  '#68BC00',
  '#16A5A5',
  '#009CE0',
  '#7B10D8',
  '#F06292',
  '#000',
  '#777',
  '#FFF'
];
